module.exports = __webpack_public_path__ + "static/media/icon-home.b0d15e6c.svg";